<template>
	<div v-loading="loading">
		<div id="wrap" class="wrap_page fixed">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="企业信息" name="first"></el-tab-pane>
				<el-tab-pane label="经济效益" name="second"></el-tab-pane>
				<el-tab-pane label="专业化程度" name="third"></el-tab-pane>
				<el-tab-pane label="创新能力" name="fourth"></el-tab-pane>
				<el-tab-pane label="经营管理" name="six"></el-tab-pane>
				<el-tab-pane label="资料生成" name="seven"></el-tab-pane>
			</el-tabs>
		</div>

		<div class="wrap wrap_page" style="margin-top:70px;">
			<div class="text">
				研发机构建设情况(企业自建或与高等院校、科研机构联合建立)
			</div>

			<div class="content cont_top">
				<div class="title_l">
					技术研究院
				</div>
				<el-form
					class="flex flex-justify cont_r"
					:rules="rules"
					:model="param"
					ref="ruleForm1"
					label-position="top"
				>
					<el-form-item
						label="国家级个数"
						prop="zjtxResearchInstitutionConstructionBO.tecInstitutesCountryNumber"
					>
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="
								param.zjtxResearchInstitutionConstructionBO
									.tecInstitutesCountryNumber
							"
							oninput="value=value.replace(/[^\d]/g,'')"
						></el-input>
					</el-form-item>
					<el-form-item
						label="省级个数"
						prop="zjtxResearchInstitutionConstructionBO.tecInstitutesProvinceNumber"
					>
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="
								param.zjtxResearchInstitutionConstructionBO
									.tecInstitutesProvinceNumber
							"
							onkeyup="value=value.replace(/[^\d]/,'')"
							oninput="value=value.replace(/[^\d]/g,'')"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="content">
				<div class="title_l"></div>
				<div class="fujian cont_r">
					<div class="txt">受牌或公示证明材料</div>
					<div class="txt">
						附件说明：附件最多可上传6个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
					</div>
					<el-upload
						class="upload-demo"
						:action="uploadImgUrl"
						:on-preview="handleView"
						:on-remove="handleRemove"
						:on-success="uploadSuccess"
						:before-upload="beforeUploadZjtx"
						accept=".pdf,.docx,.doc"
						:limit="6"
						:on-exceed="handleExceed"
						:file-list="fileList6"
						:data="{ moduleType: 6 }"
						:on-error="uploadError"
					>
						<el-button size="small" type="primary"
							><i class="el-icon-upload"></i> 点击上传</el-button
						>
					</el-upload>
				</div>
			</div>

			<div class="content cont_top">
				<div class="title_l">
					企业技术中心
				</div>
				<el-form
					class="flex flex-justify cont_r"
					label-position="top"
					:model="param"
					:rules="rules"
					ref="ruleForm2"
				>
					<el-form-item
						label="国家级个数"
						prop="zjtxResearchInstitutionConstructionBO.tecCenterCountryNumber"
					>
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="
								param.zjtxResearchInstitutionConstructionBO
									.tecCenterCountryNumber
							"
							onkeyup="value=value.replace(/[^\d]/,'')"
							oninput="value=value.replace(/[^\d]/g,'')"
						></el-input>
					</el-form-item>
					<el-form-item
						label="省级个数"
						prop="zjtxResearchInstitutionConstructionBO.tecCenterProvinceNumber"
					>
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="
								param.zjtxResearchInstitutionConstructionBO
									.tecCenterProvinceNumber
							"
							onkeyup="value=value.replace(/[^\d]/,'')"
							oninput="value=value.replace(/[^\d]/g,'')"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="content">
				<div class="title_l"></div>
				<div class="fujian cont_r">
					<div class="txt">受牌或公示证明材料</div>
					<div class="txt">
						附件说明：附件最多可上传6个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
					</div>
					<el-upload
						class="upload-demo"
						:before-upload="beforeUploadZjtx"
						:action="uploadImgUrl"
						accept=".pdf,.docx,.doc"
						:on-preview="handleView"
						:on-remove="handleRemove"
						:on-success="uploadSuccess"
						:data="{ moduleType: 7 }"
						:on-exceed="handleExceed"
						:file-list="fileList7"
						:limit="6"
						:on-error="uploadError"
					>
						<el-button size="small" type="primary"
							><i class="el-icon-upload"></i> 点击上传</el-button
						>
					</el-upload>
				</div>
			</div>

			<div class="content cont_top">
				<div class="title_l">
					企业工程中心
				</div>
				<el-form
					class="flex flex-justify cont_r"
					label-position="top"
					:model="param"
					:rules="rules"
					ref="ruleForm3"
				>
					<el-form-item
						label="国家级个数"
						prop="zjtxResearchInstitutionConstructionBO.engCenterCountryNumber"
					>
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="
								param.zjtxResearchInstitutionConstructionBO
									.engCenterCountryNumber
							"
							onkeyup="value=value.replace(/[^\d]/,'')"
							oninput="value=value.replace(/[^\d]/g,'')"
						></el-input>
					</el-form-item>
					<el-form-item
						label="省级个数"
						prop="zjtxResearchInstitutionConstructionBO.engCenterProvinceNumber"
					>
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="
								param.zjtxResearchInstitutionConstructionBO
									.engCenterProvinceNumber
							"
							onkeyup="value=value.replace(/[^\d]/,'')"
							oninput="value=value.replace(/[^\d]/g,'')"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="content">
				<div class="title_l"></div>
				<div class="fujian cont_r">
					<div class="txt">受牌或公示证明材料</div>
					<div class="txt">
						附件说明：附件最多可上传6个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
					</div>
					<el-upload
						class="upload-demo"
						:action="uploadImgUrl"
						:on-preview="handleView"
						accept=".pdf,.docx,.doc"
						:before-upload="beforeUploadZjtx"
						:on-remove="handleRemove"
						:on-success="uploadSuccess"
						:limit="6"
						:on-error="uploadError"
						:on-exceed="handleExceed"
						:file-list="fileList8"
						:data="{ moduleType: 8 }"
					>
						<el-button size="small" type="primary"
							><i class="el-icon-upload"></i> 点击上传</el-button
						>
					</el-upload>
				</div>
			</div>

			<div class="content cont_top">
				<div class="title_l"><i class="red">*</i> 院士专家工作站</div>
				<el-form ref="ruleForm4" :model="param" :rules="rules">
					<el-form-item
						prop="zjtxResearchInstitutionConstructionBO.academicianExpertWorkstation"
						required
					>
						<div>
							<el-radio-group
								v-model="
									param.zjtxResearchInstitutionConstructionBO
										.academicianExpertWorkstation
								"
							>
								<el-radio
									v-for="item in options"
									:key="item.value"
									:label="item.value"
									@change="change_fn3"
									>{{ item.label }}</el-radio
								>
							</el-radio-group>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div class="content" v-show="clock3">
				<div class="title_l"></div>
				<div class="fujian cont_r">
					<div class="txt">认定证明材料</div>
					<div class="txt">
						附件说明：附件最多可上传6个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
					</div>
					<el-upload
						class="upload-demo"
						:action="uploadImgUrl"
						accept=".pdf,.docx,.doc"
						:before-upload="beforeUploadZjtx"
						:on-preview="handleView"
						:on-remove="handleRemove"
						:on-success="uploadSuccess"
						:limit="6"
						:on-error="uploadError"
						:on-exceed="handleExceed"
						:file-list="fileList9"
						:data="{ moduleType: 9 }"
					>
						<el-button size="small" type="primary"
							><i class="el-icon-upload"></i> 点击上传</el-button
						>
					</el-upload>
				</div>
			</div>

			<div class="content cont_top">
				<div class="title_l"><i class="red">*</i> 博士后工作站</div>
				<el-form ref="ruleForm5" :model="param" :rules="rules">
					<el-form-item
						prop="zjtxResearchInstitutionConstructionBO.postdoctoralWorkstation"
					>
						<div>
							<el-radio-group
								v-model="
									param.zjtxResearchInstitutionConstructionBO
										.postdoctoralWorkstation
								"
							>
								<el-radio
									v-for="item in options"
									:key="item.value"
									:label="item.value"
									@change="change_fn4"
									>{{ item.label }}</el-radio
								>
							</el-radio-group>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div class="content" v-show="clock4">
				<div class="title_l"></div>
				<div class="fujian cont_r">
					<div class="txt">认定证明材料</div>
					<div class="txt">
						附件说明：附件最多可上传6个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
					</div>
					<el-upload
						class="upload-demo"
						:action="uploadImgUrl"
						accept=".pdf,.docx,.doc"
						:before-upload="beforeUploadZjtx"
						:on-preview="handleView"
						:on-remove="handleRemove"
						:on-success="uploadSuccess"
						:limit="6"
						:on-error="uploadError"
						:on-exceed="handleExceed"
						:file-list="fileList19"
						:data="{ moduleType: 19 }"
					>
						<el-button size="small" type="primary"
							><i class="el-icon-upload"></i> 点击上传</el-button
						>
					</el-upload>
				</div>
			</div>

			<div class="content cont_top">
				<div class="title_l"><i class="red">*</i> 合作院校机构名称</div>
				<el-form
					class="flex flex-justify cont_r flex-wrap"
					label-position="top"
					:rules="rules"
					:model="param"
					ref="ruleForm6"
				>
					<el-form-item
						label="合作院校机构-1"
						prop="zjtxResearchInstitutionConstructionBO.partnerInstitutionOne"
					>
						<el-input
							placeholder="请输入"
							v-model="
								param.zjtxResearchInstitutionConstructionBO
									.partnerInstitutionOne
							"
						></el-input>
					</el-form-item>
					<el-form-item label="合作院校机构-2">
						<el-input
							placeholder="请输入"
							v-model="
								param.zjtxResearchInstitutionConstructionBO
									.partnerInstitutionTwo
							"
						></el-input>
					</el-form-item>
					<el-form-item label="合作院校机构-3">
						<el-input
							placeholder="请输入"
							v-model="
								param.zjtxResearchInstitutionConstructionBO
									.partnerInstitutionThree
							"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="content">
				<div class="title_l"></div>
				<div class="fujian cont_r">
					<div class="txt">受牌或公示证明材料</div>
					<div class="txt">
						附件说明：附件最多可上传6个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
					</div>
					<el-upload
						class="upload-demo"
						:action="uploadImgUrl"
						:before-upload="beforeUploadZjtx"
						:on-preview="handleView"
						:on-remove="handleRemove"
						accept=".pdf,.docx,.doc"
						:on-success="uploadSuccess"
						:on-error="uploadError"
						:limit="6"
						:on-exceed="handleExceed"
						:file-list="fileList10"
						:data="{ moduleType: 10 }"
					>
						<el-button size="small" type="primary"
							><i class="el-icon-upload"></i> 点击上传</el-button
						>
					</el-upload>
				</div>
			</div>

			<div class="content cont_top">
				<div
					class="title_l"
					style="line-height:20px;width:180px;margin-right:20px;"
				>
					<i class="red">*</i> 研究领域已获得成果及应用情况<br />(30字以内)
				</div>
				<el-form ref="ruleForm7" :model="param" :rules="rules">
					<el-form-item
						prop="zjtxResearchInstitutionConstructionBO.achievement"
					>
						<div class="textarea">
							<el-input
								type="textarea"
								v-model="
									param.zjtxResearchInstitutionConstructionBO.achievement
								"
								placeholder="输入内容30字以内"
								maxlength="30"
								show-word-limit
							></el-input>
						</div>
					</el-form-item>
				</el-form>
			</div>
		</div>

		<div class="wrap wrap_page">
			<div class="text">相关指标</div>
			<div class="contents" style="margin-left: 100px">
				<div class="item flex flex-around">
					<div></div>
					<div>{{ param.zjtxAnnualCorrelationIndexBO[0].annual }}年</div>
					<div>{{ param.zjtxAnnualCorrelationIndexBO[1].annual }}年</div>
				</div>
				<div class="item flex flex-around">
					<div>研发经费总额</div>
					<div>
						<el-input
							placeholder="请输入"
							maxlength="20"
							v-model="param.zjtxAnnualCorrelationIndexBO[0].totalAmount"
							onkeyup="value=value.replace(/[^\d.]/,'')"
						></el-input>
					</div>
					<div>
						<el-input
							placeholder="请输入"
							maxlength="20"
							v-model="param.zjtxAnnualCorrelationIndexBO[1].totalAmount"
							onkeyup="value=value.replace(/[^\d.]/,'')"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>研发经费占营业收入比重</div>
					<div>
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="param.zjtxAnnualCorrelationIndexBO[0].expenditureRate"
							onkeyup="value=value.replace(/[^\d.]/,'')"
						></el-input>
					</div>
					<div>
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="param.zjtxAnnualCorrelationIndexBO[1].expenditureRate"
							onkeyup="value=value.replace(/[^\d.]/,'')"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>研发人员占全部职工比重</div>
					<div>
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="
								param.zjtxAnnualCorrelationIndexBO[0].researchPersonnelRate
							"
							onkeyup="value=value.replace(/[^\d.]/,'')"
						></el-input>
					</div>
					<div>
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="
								param.zjtxAnnualCorrelationIndexBO[1].researchPersonnelRate
							"
							onkeyup="value=value.replace(/[^\d.]/,'')"
						></el-input>
					</div>
				</div>
			</div>
		</div>

		<div class="wrap wrap_page">
			<div class="text">拥有专利情况</div>
			<div class="content cont_top">
				<el-form
					class="flex flex-justify cont_r flex-wrap"
					label-position="top"
				>
					<el-form-item label="有效专利总数（项）">
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="param.zjtxPatentSituationBO.inForcePatent"
							onkeyup="value=value.replace(/[^\d]/,'')"
						></el-input>
					</el-form-item>
					<el-form-item label="发明专利（项）">
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="param.zjtxPatentSituationBO.inventionPatent"
							onkeyup="value=value.replace(/[^\d]/,'')"
						></el-input>
					</el-form-item>
					<el-form-item label="实用新型专利（项）">
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="param.zjtxPatentSituationBO.utilityModelsPatent"
							onkeyup="value=value.replace(/[^\d]/,'')"
						></el-input>
					</el-form-item>
					<el-form-item label="外观设计专利（项）">
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="param.zjtxPatentSituationBO.designPatent"
							onkeyup="value=value.replace(/[^\d]/,'')"
						></el-input>
					</el-form-item>
					<el-form-item label="软件著作权（项）">
						<el-input
							placeholder="请输入"
							maxlength="10"
							v-model="param.zjtxPatentSituationBO.softwareCopyright"
							onkeyup="value=value.replace(/[^\d]/,'')"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="content">
				<div class="fujian cont_r">
					<div class="txt">受牌或公示证明材料</div>
					<div class="txt">
						附件说明：附件最多可上传6个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
					</div>
					<el-upload
						class="upload-demo"
						:action="uploadImgUrl"
						:on-preview="handleView"
						:before-upload="beforeUploadZjtx"
						:on-remove="handleRemove"
						:on-success="uploadSuccess"
						accept=".pdf,.docx,.doc"
						:on-error="uploadError"
						:limit="6"
						:on-exceed="handleExceed"
						:file-list="fileList11"
						:data="{ moduleType: 11 }"
					>
						<el-button size="small" type="primary"
							><i class="el-icon-upload"></i> 点击上传</el-button
						>
					</el-upload>
				</div>
			</div>
		</div>

		<div class="wrap wrap_page">
			<div class="text">主持或参与制（修）的标准数量和名称</div>
			<div class="contents" style="margin-left: 100px">
				<div class="item flex flex-around">
					<div></div>
					<div>
						{{
							param.zjtxAnnualParticipationSetStandardInformationBO[0].annual
						}}年
					</div>
					<div>
						{{
							param.zjtxAnnualParticipationSetStandardInformationBO[1].annual
						}}年
					</div>
				</div>
				<div class="item flex flex-around">
					<div>名称</div>
					<div>
						<el-input
							placeholder="请输入"
							v-model="
								param.zjtxAnnualParticipationSetStandardInformationBO[0]
									.standardName
							"
						></el-input>
					</div>
					<div>
						<el-input
							placeholder="请输入"
							v-model="
								param.zjtxAnnualParticipationSetStandardInformationBO[1]
									.standardName
							"
						></el-input>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>主持制（修）</div>
					<div>
						<el-input-number
							style="width:50%;"
							:controls="false"
							max="9999999999"
							min="0"
							placeholder="请输入"
							v-model="
								param.zjtxAnnualParticipationSetStandardInformationBO[0]
									.presideOverNumber
							"
						></el-input-number>
					</div>
					<div>
						<el-input-number
							style="width:50%;"
							:controls="false"
							max="9999999999"
							min="0"
							placeholder="请输入"
							v-model="
								param.zjtxAnnualParticipationSetStandardInformationBO[1]
									.presideOverNumber
							"
						></el-input-number>
					</div>
				</div>
				<div class="item flex flex-around">
					<div>参与制（修）</div>
					<div>
						<el-input-number
							style="width:50%;"
							:controls="false"
							max="9999999999"
							min="0"
							placeholder="请输入"
							v-model="
								param.zjtxAnnualParticipationSetStandardInformationBO[0]
									.participationNumber
							"
						></el-input-number>
					</div>
					<div>
						<el-input-number
							style="width:50%;"
							:controls="false"
							max="9999999999"
							min="0"
							placeholder="请输入"
							v-model="
								param.zjtxAnnualParticipationSetStandardInformationBO[1]
									.participationNumber
							"
						></el-input-number>
					</div>
				</div>
			</div>

			<div class="content">
				<div class="fujian cont_r">
					<div class="txt">佐证材料及支持或参与制（修）定标准一览表</div>
					<div class="txt">
						附件说明：附件最多可上传3个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
					</div>
					<el-upload
						class="upload-demo"
						:action="uploadImgUrl"
						:on-preview="handleView"
						:before-upload="beforeUploadZjtx"
						:on-success="uploadSuccess"
						:on-remove="handleRemove"
						accept=".pdf,.docx,.doc"
						:on-error="uploadError"
						:limit="3"
						:on-exceed="handleExceed"
						:file-list="fileList12"
						:data="{ moduleType: 12 }"
					>
						<el-button size="small" type="primary"
							><i class="el-icon-upload"></i> 点击上传</el-button
						>
					</el-upload>
				</div>
			</div>
		</div>

		<div class="wrap wrap_page">
			<div class="text">数字化赋能</div>

			<div class="content cont_top">
				<div style="margin-right: 100px; width: 350px">
					业务系统是否向云端迁移
				</div>
				<div>
					<el-radio
						v-for="item in options2"
						v-model="param.zjtxDigitalEmpowermentBO.isMigrationToCloud"
						:key="item.value"
						:label="item.value"
						>{{ item.label }}</el-radio
					>
				</div>
			</div>
			<div class="content cont_top">
				<div style="margin-right: 100px; width: 350px">
					是否拥有制造业与互联网融合试点示范项目
				</div>
				<div>
					<el-radio
						v-for="item in options2"
						v-model="param.zjtxDigitalEmpowermentBO.isDemonstrationProject"
						:key="item.value"
						:label="item.value"
						>{{ item.label }}</el-radio
					>
				</div>
			</div>
		</div>

		<div class="wrap wrap_page">
			<div class="text">核心业务采用信息系统支撑情况（可多选）</div>

			<div class="content cont_top">
				<el-checkbox-group v-model="coreBusinessChecked">
					<el-checkbox
						v-for="item in coreBusiness"
						:key="item.dictCode"
						:label="item.dictCode"
						>{{ item.dictName }}</el-checkbox
					>
				</el-checkbox-group>
			</div>
			<div class="content cont_top">
				<el-input
					type="textarea"
					placeholder="请说明"
					v-model="coreBusinessIntroduce"
					maxlength="400"
					show-word-limit
				></el-input>
			</div>

			<div class="content cont_top">
				<div class="fujian cont_r">
					<div class="txt">
						企业核心业务采用信息系统支撑的佐证材料（使用协议、运行截图等）
					</div>
					<div class="txt">
						附件说明：附件最多可上传10个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
					</div>
					<el-upload
						class="upload-demo"
						:action="uploadImgUrl"
						:before-upload="beforeUploadZjtx"
						:on-preview="handleView"
						:on-remove="handleRemove"
						:on-success="uploadSuccess"
						:on-error="uploadError"
						accept=".pdf,.docx,.doc"
						:limit="10"
						:on-exceed="handleExceed"
						:file-list="fileList13"
						:data="{ moduleType: 13 }"
					>
						<el-button size="small" type="primary"
							><i class="el-icon-upload"></i> 点击上传</el-button
						>
					</el-upload>
				</div>
			</div>
		</div>

		<div class="wrap wrap_page">
			<div class="text">获得相关部门认定的称号（有效期内）</div>

			<div class="content cont_top">
				<el-checkbox-group v-model="titlesChecked">
					<el-checkbox
						v-for="item in titles"
						:key="item.dictCode"
						:label="item.dictCode"
						>{{ item.dictName }}</el-checkbox
					>
				</el-checkbox-group>
			</div>
			<div class="content cont_top">
				<el-input
					type="textarea"
					placeholder="请说明"
					v-model="titleIntroduce"
					maxlength="400"
					show-word-limit
				></el-input>
			</div>

			<div class="content cont_top">
				<div class="fujian cont_r">
					<div class="txt">部门认定佐证材料</div>
					<div class="txt">
						附件说明：附件最多可上传3个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
					</div>
					<el-upload
						class="upload-demo"
						:action="uploadImgUrl"
						:on-preview="handleView"
						:before-upload="beforeUploadZjtx"
						:on-remove="handleRemove"
						:on-success="uploadSuccess"
						:on-error="uploadError"
						:limit="3"
						:on-exceed="handleExceed"
						:file-list="fileList14"
						:data="{ moduleType: 14 }"
					>
						<el-button size="small" type="primary"
							><i class="el-icon-upload"></i> 点击上传</el-button
						>
					</el-upload>
				</div>
			</div>
		</div>

		<div class="wrap wrap_page">
			<div class="text">近2年是否承担过国家重大科技项目</div>

			<div class="content cont_top">
				<div>
					<el-radio
						v-for="item in options2"
						v-model="param.zjtxRecentTowYearsInformationBO1.result"
						:key="item.value"
						:label="item.value"
						@change="change_fn1"
						>{{ item.label }}</el-radio
					>
				</div>
			</div>
			<div v-show="clock">
				<div class="content cont_top">
					<div style="width: 100px">
						名称
					</div>
					<div>
						<el-input
							placeholder="输入内容"
							v-model="param.zjtxRecentTowYearsInformationBO1.projectName"
						></el-input>
					</div>
				</div>
				<div class="content cont_top">
					<div class="fujian cont_r">
						<div class="txt">相关佐证材料</div>
						<div class="txt">
							附件说明：附件最多可上传3个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
						</div>
						<el-upload
							class="upload-demo"
							:action="uploadImgUrl"
							:on-preview="handleView"
							:before-upload="beforeUploadZjtx"
							:on-remove="handleRemove"
							:on-success="uploadSuccess"
							:on-error="uploadError"
							:limit="3"
							:data="{ moduleType: 15 }"
							:on-exceed="handleExceed"
							:file-list="fileList15"
						>
							<el-button size="small" type="primary"
								><i class="el-icon-upload"></i> 点击上传</el-button
							>
						</el-upload>
					</div>
				</div>
			</div>
		</div>

		<div class="wrap wrap_page">
			<div class="text">近2年是否获得过国家级技术创新类项目</div>

			<div class="content cont_top">
				<div>
					<el-radio
						v-for="item in options2"
						v-model="param.zjtxRecentTowYearsInformationBO2.result"
						:key="item.value"
						:label="item.value"
						@change="change_fn2"
						>{{ item.label }}</el-radio
					>
				</div>
			</div>
			<div v-show="clock2">
				<div class="content cont_top">
					<div style="width: 100px">
						名称
					</div>
					<div>
						<el-input
							placeholder="输入内容"
							v-model="param.zjtxRecentTowYearsInformationBO2.projectName"
						></el-input>
					</div>
				</div>
				<div class="content cont_top">
					<div class="fujian cont_r">
						<div class="txt">相关佐证材料</div>
						<div class="txt">
							附件说明：附件最多可上传3个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
						</div>
						<el-upload
							class="upload-demo"
							:action="uploadImgUrl"
							:on-preview="handleView"
							:before-upload="beforeUploadZjtx"
							:on-remove="handleRemove"
							:on-success="uploadSuccess"
							:on-error="uploadError"
							:limit="3"
							:on-exceed="handleExceed"
							:file-list="fileList16"
							:data="{ moduleType: 16 }"
						>
							<el-button size="small" type="primary"
								><i class="el-icon-upload"></i> 点击上传</el-button
							>
						</el-upload>
					</div>
				</div>
			</div>
		</div>

		<div class="flex flex-center" style="margin-top:20px;">
			<el-button type="primary" @click="save()">保存</el-button>
			<el-button type="primary" @click="reset()">重置</el-button>
			<el-button type="primary" @click="nextPage()">下一项</el-button>
		</div>
	</div>
</template>

<script>
import { getDict } from "@/api/ChinaHigh";
import {
	getMultiFiles,
	saveInnovation,
	getInnovationBaseInfo
} from "@/api/specialization";
export default {
	data() {
		return {
			loading: false,
			clock: true,
			clock2: true,
			clock3: true,
			clock4: true,
			activeName: "fourth",
			radio: "1",
			fileList6: [],
			fileList7: [],
			fileList8: [],
			fileList9: [],
			fileList10: [],
			fileList11: [],
			fileList12: [],
			fileList13: [],
			fileList14: [],
			fileList15: [],
			fileList16: [],
			fileList19: [],
			ruleForm: {
				name: "",
				desc: ""
			},
			options: [
				{ value: 1, label: "有" },
				{ value: 2, label: "无" }
			],
			options2: [
				{ value: 1, label: "是" },
				{ value: 2, label: "否" }
			],
			coreBusiness: [],
			coreBusinessChecked: [],
			coreBusinessIntroduce: "",
			titles: [],
			titlesChecked: [],
			titleIntroduce: "",
			elses: false,
			param: {
				files: [],
				zjtxResearchInstitutionConstructionBO: {},
				zjtxAnnualCorrelationIndexBO: [{ annual: 2019 }, { annual: 2020 }],
				zjtxPatentSituationBO: {},
				zjtxAnnualParticipationSetStandardInformationBO: [
					{ annual: 2019 },
					{ annual: 2020 }
				],
				zjtxDigitalEmpowermentBO: {},
				zjtxMultipleChoiceRecordBO: [],
				zjtxRecentTowYearsInformationBO1: { type: 1 },
				zjtxRecentTowYearsInformationBO2: { type: 2 },
				zjtxRecentTowYearsInformationBO: [],
				zjtxProjectBO: {}
			},
			idResponse: {},
			rules: {
				"zjtxResearchInstitutionConstructionBO.tecInstitutesCountryNumber": [
					{ required: true, message: "请填写该数据", trigger: "blur" }
				],
				"zjtxResearchInstitutionConstructionBO.tecInstitutesProvinceNumber": [
					{ required: true, message: "请填写该数据", trigger: "blur" }
				],
				"zjtxResearchInstitutionConstructionBO.tecCenterCountryNumber": [
					{ required: true, message: "请填写该数据", trigger: "blur" }
				],
				"zjtxResearchInstitutionConstructionBO.engCenterProvinceNumber": [
					{ required: true, message: "请填写该数据", trigger: "blur" }
				],
				"zjtxResearchInstitutionConstructionBO.engCenterCountryNumber": [
					{ required: true, message: "请填写该数据", trigger: "blur" }
				],
				"zjtxResearchInstitutionConstructionBO.postdoctoralWorkstation": [
					{ required: true, message: " ", trigger: "change" }
				],
				"zjtxResearchInstitutionConstructionBO.academicianExpertWorkstation": [
					{ required: true, message: " ", trigger: "change" }
				],
				"zjtxResearchInstitutionConstructionBO.achievement": [
					{ required: true, message: "请填写该数据", trigger: "blur" }
				],
				"zjtxResearchInstitutionConstructionBO.tecCenterProvinceNumber": [
					{ required: true, message: "请填写该数据", trigger: "blur" }
				],
				"zjtxResearchInstitutionConstructionBO.partnerInstitutionOne": [
					{ required: true, message: "请至少填写一个", trigger: "blur" }
				]
			}
		};
	},
	created() {
		this.init();
	},
	methods: {
		change_fn1(e) {
			if (e == 1) {
				this.clock = true;
			} else {
				this.clock = false;
			}
		},
		change_fn2(e) {
			if (e == 1) {
				this.clock2 = true;
			} else {
				this.clock2 = false;
			}
		},
		change_fn3(e) {
			if (e == 1) {
				this.clock3 = true;
			} else {
				this.clock3 = false;
			}
		},
		change_fn4(e) {
			if (e == 1) {
				this.clock4 = true;
			} else {
				this.clock4 = false;
			}
		},

		nextPage() {
			this.zjtxRecentTowYearsInformationBO = [];
			this.zjtxRecentTowYearsInformationBO.push(
					this.zjtxRecentTowYearsInformationBO1
			);
			this.zjtxRecentTowYearsInformationBO.push(
					this.zjtxRecentTowYearsInformationBO2
			);
			let result = false;
			this.$refs["ruleForm1"].validate(valid => {
				result = valid;
			});
			this.$refs["ruleForm2"].validate(valid => {
				result = valid;
			});
			this.$refs["ruleForm3"].validate(valid => {
				result = valid;
			});
			this.$refs["ruleForm4"].validate(valid => {
				result = valid;
			});
			this.$refs["ruleForm5"].validate(valid => {
				result = valid;
			});
			this.$refs["ruleForm6"].validate(valid => {
				result = valid;
			});
			this.$refs["ruleForm7"].validate(valid => {
				result = valid;
			});
			if (result) {
				this.param.files = [
					{ moduleType: 6 },
					{ moduleType: 7 },
					{ moduleType: 8 },
					{ moduleType: 9 },
					{ moduleType: 10 },
					{ moduleType: 11 },
					{ moduleType: 12 },
					{ moduleType: 13 },
					{ moduleType: 14 },
					{ moduleType: 15 },
					{ moduleType: 16 },
					{ moduleType: 19 }
				];
				this.fileList6.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList7.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList8.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList9.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList10.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList11.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList12.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList13.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList14.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList15.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList16.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList19.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				console.log(this.param.files);

				let answer = "";
				this.coreBusinessChecked.forEach(res => {
					answer = answer + res + ",";
				});
				this.param.zjtxMultipleChoiceRecordBO = [];
				if (Object.keys(this.idResponse).length > 0) {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "3",
						introduce: this.coreBusinessIntroduce,
						id: this.idResponse.MultipleChoiceRecord0
					});
				} else {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "3",
						introduce: this.coreBusinessIntroduce
					});
				}
				answer = "";
				this.titlesChecked.forEach(res => {
					answer = answer + res + ",";
				});
				if (Object.keys(this.idResponse).length > 0) {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "4",
						introduce: this.titleIntroduce,
						id: this.idResponse.MultipleChoiceRecord1
					});
				} else {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "4",
						introduce: this.titleIntroduce
					});
				}
				this.param.zjtxRecentTowYearsInformationBO.push(
						this.param.zjtxRecentTowYearsInformationBO1
				);
				this.param.zjtxRecentTowYearsInformationBO.push(
						this.param.zjtxRecentTowYearsInformationBO2
				);
				saveInnovation(this.param).then(res => {
					if (res.code == "00000") {
						if (res.data != null) {
							this.idResponse = res.data;
							this.param.zjtxAnnualCorrelationIndexBO[0].id =
									res.data.AnnualCorrelationIndex0;
							this.param.zjtxAnnualCorrelationIndexBO[1].id =
									res.data.AnnualCorrelationIndex1;
							this.param.zjtxAnnualParticipationSetStandardInformationBO[0].id =
									res.data.AnnualParticipationSetStandardInformation0;
							this.param.zjtxAnnualParticipationSetStandardInformationBO[1].id =
									res.data.AnnualParticipationSetStandardInformation1;
							this.param.zjtxDigitalEmpowermentBO.id =
									res.data.DigitalEmpowerment;
							this.param.zjtxPatentSituationBO.id = res.data.PatentSituation;
							this.param.zjtxRecentTowYearsInformationBO1.id =
									res.data.RecentTowYearsInformation0;
							this.param.zjtxRecentTowYearsInformationBO2.id =
									res.data.RecentTowYearsInformation1;
							this.param.zjtxResearchInstitutionConstructionBO.id =
									res.data.ResearchInstitutionConstructionId;
						}
						this.msgSuccess("操作成功");
						this.$router.push("/centerform/specializationManagement");
					}
				});
			}
		},
		reset() {
			this.titleIntroduce = "";
			this.coreBusinessIntroduce = "";
			this.param.zjtxProjectBO = { id: this.param.zjtxProjectBO.id };
			this.param.files = [];
			this.param.zjtxResearchInstitutionConstructionBO = {
				id: this.param.zjtxResearchInstitutionConstructionBO.id
			};
			this.param.zjtxAnnualCorrelationIndexBO = [
				{
					id: this.param.zjtxAnnualCorrelationIndexBO[0].id,
					annual: this.param.zjtxAnnualCorrelationIndexBO[0].annual
				},
				{
					id: this.param.zjtxAnnualCorrelationIndexBO[1].id,
					annual: this.param.zjtxAnnualCorrelationIndexBO[1].annual
				}
			];

			this.param.zjtxAnnualParticipationSetStandardInformationBO = [
				{
					id: this.param.zjtxAnnualParticipationSetStandardInformationBO[0].id,
					annual: this.param.zjtxAnnualParticipationSetStandardInformationBO[0]
						.annual
				},
				{
					id: this.param.zjtxAnnualParticipationSetStandardInformationBO[1].id,
					annual: this.param.zjtxAnnualParticipationSetStandardInformationBO[1]
						.annual
				}
			];
			this.param.zjtxPatentSituationBO = {
				id: this.param.zjtxPatentSituationBO.id
			};
			this.param.zjtxDigitalEmpowermentBO = {
				id: this.param.zjtxDigitalEmpowermentBO.id
			};
			this.param.zjtxMultipleChoiceRecordBO = [];
			this.param.zjtxRecentTowYearsInformationBO = [];
			this.param.zjtxRecentTowYearsInformationBO1 = { type: 1 };
			this.param.zjtxRecentTowYearsInformationBO2 = { type: 2 };
			this.titlesChecked = [];
			this.coreBusinessChecked = [];
			this.emptyFileList();
		},
		emptyFileList() {
			this.fileList6 = [];
			this.fileList7 = [];
			this.fileList8 = [];
			this.fileList9 = [];
			this.fileList10 = [];
			this.fileList11 = [];
			this.fileList12 = [];
			this.fileList13 = [];
			this.fileList14 = [];
			this.fileList15 = [];
			this.fileList16 = [];
			this.fileList19 = [];
		},
		save() {
			this.zjtxRecentTowYearsInformationBO = [];
			this.zjtxRecentTowYearsInformationBO.push(
				this.zjtxRecentTowYearsInformationBO1
			);
			this.zjtxRecentTowYearsInformationBO.push(
				this.zjtxRecentTowYearsInformationBO2
			);
			let result = false;
			this.$refs["ruleForm1"].validate(valid => {
				result = valid;
			});
			this.$refs["ruleForm2"].validate(valid => {
				result = valid;
			});
			this.$refs["ruleForm3"].validate(valid => {
				result = valid;
			});
			this.$refs["ruleForm4"].validate(valid => {
				result = valid;
			});
			this.$refs["ruleForm5"].validate(valid => {
				result = valid;
			});
			this.$refs["ruleForm6"].validate(valid => {
				result = valid;
			});
			this.$refs["ruleForm7"].validate(valid => {
				result = valid;
			});
			if (result) {
				this.param.files = [
					{ moduleType: 6 },
					{ moduleType: 7 },
					{ moduleType: 8 },
					{ moduleType: 9 },
					{ moduleType: 10 },
					{ moduleType: 11 },
					{ moduleType: 12 },
					{ moduleType: 13 },
					{ moduleType: 14 },
					{ moduleType: 15 },
					{ moduleType: 16 },
					{ moduleType: 19 }
				];
				this.fileList6.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList7.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList8.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList9.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList10.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList11.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList12.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList13.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList14.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList15.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList16.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				this.fileList19.forEach(res => {
					// console.log(res);
					if (res.response == undefined) {
						this.param.files.push(res);
					} else {
						this.param.files.push(res.response.data);
					}
				});
				console.log(this.param.files);

				let answer = "";
				this.coreBusinessChecked.forEach(res => {
					answer = answer + res + ",";
				});
				this.param.zjtxMultipleChoiceRecordBO = [];
				if (Object.keys(this.idResponse).length > 0) {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "3",
						introduce: this.coreBusinessIntroduce,
						id: this.idResponse.MultipleChoiceRecord0
					});
				} else {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "3",
						introduce: this.coreBusinessIntroduce
					});
				}
				answer = "";
				this.titlesChecked.forEach(res => {
					answer = answer + res + ",";
				});
				if (Object.keys(this.idResponse).length > 0) {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "4",
						introduce: this.titleIntroduce,
						id: this.idResponse.MultipleChoiceRecord1
					});
				} else {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "4",
						introduce: this.titleIntroduce
					});
				}
				this.param.zjtxRecentTowYearsInformationBO.push(
					this.param.zjtxRecentTowYearsInformationBO1
				);
				this.param.zjtxRecentTowYearsInformationBO.push(
					this.param.zjtxRecentTowYearsInformationBO2
				);
				saveInnovation(this.param).then(res => {
					if (res.code == "00000") {
						if (res.data != null) {
							this.idResponse = res.data;
							this.param.zjtxAnnualCorrelationIndexBO[0].id =
								res.data.AnnualCorrelationIndex0;
							this.param.zjtxAnnualCorrelationIndexBO[1].id =
								res.data.AnnualCorrelationIndex1;
							this.param.zjtxAnnualParticipationSetStandardInformationBO[0].id =
								res.data.AnnualParticipationSetStandardInformation0;
							this.param.zjtxAnnualParticipationSetStandardInformationBO[1].id =
								res.data.AnnualParticipationSetStandardInformation1;
							this.param.zjtxDigitalEmpowermentBO.id =
								res.data.DigitalEmpowerment;
							this.param.zjtxPatentSituationBO.id = res.data.PatentSituation;
							this.param.zjtxRecentTowYearsInformationBO1.id =
								res.data.RecentTowYearsInformation0;
							this.param.zjtxRecentTowYearsInformationBO2.id =
								res.data.RecentTowYearsInformation1;
							this.param.zjtxResearchInstitutionConstructionBO.id =
								res.data.ResearchInstitutionConstructionId;
						}
						this.msgSuccess("操作成功");
					}
				});
			}
		},
		init() {
			getDict({ type: "core_business" }).then(res => {
				this.coreBusiness = res.data;
			});
			getDict({ type: "relevan_department_auth_title" }).then(res => {
				this.titles = res.data;
			});
			this.param.zjtxProjectBO.id = sessionStorage.getItem("zt_special_id");
			getInnovationBaseInfo(this.param.zjtxProjectBO.id).then(res => {
				this.param.zjtxAnnualCorrelationIndexBO =
					res.data.zjtxAnnualCorrelationIndexBO != null
						? res.data.zjtxAnnualCorrelationIndexBO
						: [{ annual: 2019 }, { annual: 2020 }];
				this.param.zjtxAnnualParticipationSetStandardInformationBO =
					res.data.zjtxAnnualParticipationSetStandardInformationBO != null
						? res.data.zjtxAnnualParticipationSetStandardInformationBO
						: [{ annual: 2019 }, { annual: 2019 }];
				this.param.zjtxDigitalEmpowermentBO =
					res.data.zjtxDigitalEmpowermentBO != null
						? res.data.zjtxDigitalEmpowermentBO
						: {};
				this.param.zjtxPatentSituationBO =
					res.data.zjtxPatentSituationBO != null
						? res.data.zjtxPatentSituationBO
						: {};
				res.data.zjtxRecentTowYearsInformationBO.forEach(item => {
					if (item.type == 1) {
						this.param.zjtxRecentTowYearsInformationBO1 = item;
					} else if (item.type == 2) {
						this.param.zjtxRecentTowYearsInformationBO2 = item;
					}
				});
				this.param.zjtxResearchInstitutionConstructionBO =
					res.data.zjtxResearchInstitutionConstructionBO != null
						? res.data.zjtxResearchInstitutionConstructionBO
						: {};
				res.data.zjtxMultipleChoiceRecordBO.forEach(item => {
					if (item.relationType == 3) {
						let answer = item.answer;
						this.idResponse.MultipleChoiceRecord0 = item.id;
						if (answer != null) {
							answer.split(",").forEach(itm => {
								this.coreBusinessChecked.push(parseInt(itm));
							});
						}
						this.coreBusinessIntroduce = item.introduce;
					} else if (item.relationType == 4) {
						this.titleIntroduce = item.introduce;
						let answer = item.answer;
						this.idResponse.MultipleChoiceRecord1 = item.id;
						if (answer != null) {
							answer.split(",").forEach(itm => {
								this.titlesChecked.push(parseInt(itm));
							});
						}
					}
				});
				if (
					this.param.zjtxResearchInstitutionConstructionBO
						.academicianExpertWorkstation == 2
				) {
					this.clock3 = false;
				} else {
					this.clock3 = true;
				}
				if (
					this.param.zjtxResearchInstitutionConstructionBO
						.postdoctoralWorkstation == 2
				) {
					this.clock4 = false;
				} else {
					this.clock4 = true;
				}
				if (this.param.zjtxRecentTowYearsInformationBO1.result == 2) {
					this.clock = false;
				} else {
					this.clock = true;
				}
				if (this.param.zjtxRecentTowYearsInformationBO2.result == 2) {
					this.clock2 = false;
				} else {
					this.clock2 = true;
				}
			});
			getMultiFiles({
				moduleId: sessionStorage.getItem("zt_special_id"),
				moduleTypes: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 19]
			}).then(res => {
				this.emptyFileList();
				res.data.forEach(re => {
					if (re.moduleType == 6) {
						this.fileList6.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					}
					if (re.moduleType == 7) {
						this.fileList7.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					}
					if (re.moduleType == 8) {
						this.fileList8.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					}
					if (re.moduleType == 9) {
						this.fileList9.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					}
					if (re.moduleType == 10) {
						this.fileList10.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					}
					if (re.moduleType == 11) {
						this.fileList11.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					}
					if (re.moduleType == 12) {
						this.fileList12.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					}
					if (re.moduleType == 13) {
						this.fileList13.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					}
					if (re.moduleType == 14) {
						this.fileList14.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					}
					if (re.moduleType == 15) {
						this.fileList15.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					}
					if (re.moduleType == 16) {
						this.fileList16.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					}
					if (re.moduleType == 19) {
						this.fileList19.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					}
				});
			});
		},
		handleClick(tab, event) {
			this.$confirm(
				"请确认当前页数据是否填写完整并保存,否则将导致数据丢失",
				"确认离开吗?",
				{ type: "warning" }
			)
				.then(() => {
					if (tab.index == 0) {
						this.$router.push("/centerform/specializationRegistration");
					} else if (tab.index == 1) {
						this.$router.push("/centerform/specializationBenefit");
					} else if (tab.index == 2) {
						this.$router.push("/centerform/specializationProfessionalization");
					} else if (tab.index == 3) {
						this.$router.push("/centerform/specializationInnovationCapacity");
					} else if (tab.index == 4) {
						this.$router.push("/centerform/specializationManagement");
					} else if (tab.index == 5) {
						this.$router.push("/centerform/specializationDatagenerated");
					}
				})
				.catch(e => {
					this.activeName = "fourth";
				});
			console.log(tab.index);
		},
		beforeUploadZjtx(file, fileList) {
			let suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
			if (suffix != "pdf" && suffix != "doc" && suffix != "docx") {
				this.msgError("只能上传pdf/doc/docx格式的文件");
				return false;
			}
			if (file.size > 10240000) {
				this.msgError("文件最大可上传10MB,您上传的" + file.name + "已超出限制");
				return false;
			}
			// this.loading = true;
		},
		uploadError() {
			this.loading = false;
			this.msgError("上传失败");
		},
		uploadSuccess(res, file) {
			this.loading = false;
			console.log("上传", res);
			if (res.code == "00000") {
				this.msgSuccess("上传成功");
				if (res.data.moduleType == 6) {
					this.fileList6.push(file);
				}
				if (res.data.moduleType == 7) {
					this.fileList7.push(file);
				}
				if (res.data.moduleType == 8) {
					this.fileList8.push(file);
				}
				if (res.data.moduleType == 9) {
					this.fileList9.push(file);
				}
				if (res.data.moduleType == 10) {
					this.fileList10.push(file);
				}
				if (res.data.moduleType == 11) {
					this.fileList11.push(file);
				}
				if (res.data.moduleType == 12) {
					this.fileList12.push(file);
				}
				if (res.data.moduleType == 13) {
					this.fileList13.push(file);
				}
				if (res.data.moduleType == 14) {
					this.fileList14.push(file);
				}
				if (res.data.moduleType == 15) {
					this.fileList15.push(file);
				}
				if (res.data.moduleType == 16) {
					this.fileList16.push(file);
				}
				if (res.data.moduleType == 19) {
					this.fileList19.push(file);
				}
			}
		},
		handleRemove(file, fileList) {
			console.log(file);
			if (file.moduleType == 6) {
				this.fileList6 = [];
			}
			if (file.moduleType == 7) {
				this.fileList7 = [];
			}
			if (file.moduleType == 8) {
				this.fileList8 = [];
			}
			if (file.moduleType == 9) {
				this.fileList9 = [];
			}
			if (file.moduleType == 10) {
				this.fileList10 = [];
			}
			if (file.moduleType == 11) {
				this.fileList11 = [];
			}
			if (file.moduleType == 12) {
				this.fileList12 = [];
			}
			if (file.moduleType == 13) {
				this.fileList13 = [];
			}
			if (file.moduleType == 14) {
				this.fileList14 = [];
			}
			if (file.moduleType == 15) {
				this.fileList15 = [];
			}
			if (file.moduleType == 16) {
				this.fileList16 = [];
			}
			if (file.moduleType == 19) {
				this.fileList19 = [];
			}
			fileList.forEach(item => {
				if (item.moduleType == 6) {
					this.fileList6.push(item);
				}
				if (item.moduleType == 7) {
					this.fileList7.push(item);
				}
				if (item.moduleType == 8) {
					this.fileList8.push(item);
				}
				if (item.moduleType == 9) {
					this.fileList9.push(item);
				}
				if (item.moduleType == 10) {
					this.fileList10.push(item);
				}
				if (item.moduleType == 11) {
					this.fileList11.push(item);
				}
				if (item.moduleType == 12) {
					this.fileList12.push(item);
				}
				if (item.moduleType == 13) {
					this.fileList13.push(item);
				}
				if (item.moduleType == 14) {
					this.fileList14.push(item);
				}
				if (item.moduleType == 15) {
					this.fileList15.push(item);
				}
				if (item.moduleType == 16) {
					this.fileList16.push(item);
				}
				if (item.moduleType == 19) {
					this.fileList19.push(item);
				}
			});
		},
		handlePreview(file) {
			console.log(file);
		},
		handleExceed(files, fileList) {
			this.$message.warning("文件数量超过限制");
		},
		beforeRemove(file, fileList) {
			return this.$confirm(`确定移除 ${file.name}？`);
		}
	}
};
</script>

<style scoped>
.text {
	border-bottom: 1px solid #dbdbdb;
	position: relative;
	padding: 10px 20px;
}
.text::before {
	content: "";
	position: absolute;
	width: 4px;
	height: 18px;
	left: 10px;
	top: 12px;
	background: #7c99fd;
}
.icon-wujiaoxing {
	color: #d43030;
}
.content {
	width: 80%;
	display: flex;
	justify-content: flex-start;
	/* align-items: center; */
	margin-left: 100px;
}
.content .title_l {
	width: 200px;
	line-height: 40px;
}

.flex-justify .el-form-item {
	width: 40%;
}
.cont_r .txt {
	font-size: 13px;
	color: #999;
}
.upload-demo {
	margin-top: 20px;
}
.content .el-radio {
	margin-right: 20px;
}
.cont_top {
	margin-top: 40px;
}
.textarea {
	width: 100%;
}

.flex-around > div {
	flex: 1;
	margin-top: 20px;
}
.flex-around > div .el-input {
	width: 50%;
}
.wrap {
	margin-top: 15px;
}
.fujian {
	margin-top: 20px;
}
</style>
